export const DEFAULT_CENSUS_DATA_FIELDS = [
  {
    id: 'population',
    label: 'Population',
  },
  { id: 'median_household_income', label: 'Median Household Income' },
];
